// src/views/usuarios/usuarios.service.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/',
  timeout: 15000,
});

// Lista de usuarios (grupos + users)
export const fetchUsers = async ({ authorizationToken, strict = false }) => {
  const { data } = await api.get('/api/users', {
    params: {
      Authorization: authorizationToken,
      estricto: strict,
    },
  });
  // data: [{ group_name, group_id, users: [...] }, ...]
  return data;
};

// Obtener usuario por token
export const fetchUserByToken = async (idToken) => {
  const { data } = await api.get(`/api/user/${idToken}`);
  return data; // { id_token, nombre, email, activo, imagen, type, role }
};

// Actualizar usuario
export const updateUser = async (idToken, payload) => {
  const { data } = await api.post(`/api/user/update/${idToken}`, payload);
  return data; // { success: 'Usuario actualizado' } o { error }
};

// Crear usuario (admin/superadmin)
// Asumimos que el backend /api/register aceptará también "role"
export const createUser = async (payload) => {
  const { data } = await api.post('/api/register', payload);
  return data; // { success: true, ... } o { error }
};
